import React, { forwardRef } from 'react';

const Truncate = forwardRef(({ children, lines = 1, ...props }, ref) => {
  return (
    <div
      style={{
        display: '-webkit-box',
        WebkitLineClamp: lines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
      }}
      {...props}
      ref={ref}
    >
      {children}
    </div>
  );
});

export default Truncate;
